import * as yup from 'yup'

export const personalInformationValidationSchema = yup.object().shape({
  firstName: yup.string().required('This field is required'),
  lastName: yup.string().required('This field is required'),
  companyName: yup.string(),
  phone: yup.string().required('This field is required'),
  fileId: yup.string(),
})

export type PersonalInformationSchemaType = {
  firstName: string
  lastName: string
  companyName: string
  phone: string
  fileId: string
  authToken: string
}

export const personalInformationInitialValues = {
  firstName: '',
  lastName: '',
  companyName: '',
  phone: '',
  fileId: '',
  authToken: '',
}
